module.exports = JSON.parse('{"title":"Recent posts","items":[]}')